interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="flex flex-col items-center gap-4 mt-8">
      <div className="hidden sm:flex items-center justify-center gap-2 flex-wrap">
        <button
          type="button"
          disabled={current <= 1}
          onClick={() => onChange(current - 1)}
          className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
        >
          <i className="ri-arrow-left-s-line"></i>上一页
        </button>
        {pages.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-9 h-9 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer ${
              p === current
                ? "bg-primary-500 text-background-50 font-medium"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ))}
        <button
          type="button"
          disabled={current >= total}
          onClick={() => onChange(current + 1)}
          className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
        >
          下一页<i className="ri-arrow-right-s-line"></i>
        </button>
      </div>

      {current < total && (
        <button
          type="button"
          onClick={() => onChange(current + 1)}
          className="sm:hidden w-full h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          加载更多
        </button>
      )}
    </div>
  );
}